<template>
  <div class="flat-horizontal-card" v-if="asset">
    <a :href="url">
      <lazy-image
        type="horizontal"
        :src="screenshot"
        :alt="imgAlt === null ? asset.title : imgAlt"
        :title="asset.title"
      />
      <h3 class="title">{{ asset.title }}</h3>
    </a>
  </div>
</template>

<script>
import LazyImage from "@/components/utils/LaziImage.vue";

export default {
  name: "FlatHorizontalCard",
  components: { LazyImage },
  props: {
    asset: Object,
    imgAlt: {
      type: String,
    },
    default: function () {
      return null;
    },
  },
  computed: {
    screenshot() {
      return (
        "https://images.flixlatino.com/imgpath/" +
        this.asset.slug +
        "/screenshot/365_205/"
      );
    },
    url() {
      let url = this.$t("movie_route", { slug: this.asset.slug });
      if (this.asset.type === "series") {
        url = this.$t("serie_route", { slug: this.asset.slug });
      }
      return url;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.flat-horizontal-card {
  img {
    border-radius: 5px;
  }
  h3 {
    color: #ffffff;
    font-size: 0.8em;
    margin: 0.5em 0.5em;
  }
}
</style>
